import { Typography, Box } from '@mui/material';
import { Stepper, Step, StepLabel } from 'pages/AdditionalServices/ServicesList/styles';

const steps: Array<string> = [
    'Endereço',
    'Dados',
    'Token'
];

const HeaderSections = ({ step }: { step: number }) => {
    return (
        <Box sx={{
            position: { xs: 'relative', md: 'absolute' },
            inset: 0,
            top: { xs: 0, md: '1.5rem' },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            height: 'fit-content',
            margin: { xs: '.5rem auto 1rem', md: '0 auto' },
            width: '100%',
            maxWidth: { xs: '15.875rem', md: 'fit-content' }
        }}>
            <Stepper activeStep={step} alternativeLabel>
                {steps.map((label, index) => (
                    <Step key={index}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>
            <Typography sx={{
                display: step < 2 ? 'block' : 'none',
                textAlign: 'center',
                fontSize: { xs: '.9375rem', md: '1rem' },
                paddingTop: { xs: '.87rem', md: '1.5rem' }
            }}>
                <b>Confira</b> os dados abaixo e <b>altere</b> caso necessário:
            </Typography>
        </Box>
    );
}

export default HeaderSections;